import Vue from 'vue';

export const Events = Object.freeze({
  ShowHelp: 'woo:showHelp',
  PlayVideo: 'woo:playVideo',
  PauseVideo: 'woo:pauseVideo',
  ReplayVideo: 'woo:replayVideo',
  PlayNextVideo: 'woo:playNextVideo',
  PlayPreviousVideo: 'woo:playPreviousVideo',
  PlayNextHelpVideo: 'woo:playNextHelpVideo',
  PlayPreviousHelpVideo: 'woo:playPreviousHelpVideo',
  ResetHelpDrawer: 'woo:resetHelpDrawer',
});

export default new Vue();
